import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import ComingSoon from "@/pages/ComingSoon";
import Admin from "@/pages/Admin";
import Shop from "@/pages/Shop";
import Onboarding from "@/pages/Onboarding";
import Login from "@/pages/Login";
import Profile from "@/pages/Profile";
import Herzkammer from "@/pages/Herzkammer";
import AGB from "@/pages/AGB";
import Datenschutz from "@/pages/Datenschutz";
import Impressum from "@/pages/Impressum";
import { CartProvider } from "@/context/CartContext";
import { CookieProvider } from "@/context/CookieContext";
import CartDrawer from "@/components/qhearts/CartDrawer";
import CookieBanner from "@/components/qhearts/CookieBanner";
import ScrollToHash from "@/components/qhearts/ScrollToHash";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <CookieProvider>
          <CartProvider>
            <Routes>
              <Route path="/" element={<ComingSoon />} />
              <Route path="/preview" element={<Landing />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/login" element={<Login />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/lovezone" element={<Herzkammer />} />
              <Route path="/heartcore" element={<Herzkammer />} />
              <Route path="/herzkammer" element={<Herzkammer />} />
              <Route path="/agb" element={<AGB />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <CartDrawer />
            <CookieBanner />
          </CartProvider>
        </CookieProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
